/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I reuse matched text in the replacement?`)
};

const es_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo reutilizar el texto coincidente en el reemplazo?`)
};

const de_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich übereinstimmenden Text in der Ersetzung wiederverwenden?`)
};

const nl_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik gematche tekst in de vervanging opnieuw gebruiken?`)
};

const fr_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je réutiliser le texte correspondant dans le remplacement ?`)
};

const it_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso riutilizzare il testo corrispondente nella sostituzione?`)
};

const pt_br2_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso reutilizar o texto correspondente na substituição?`)
};

const pt_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso reutilizar texto correspondido na substituição?`)
};

const ja_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`置換時に一致したテキストを再利用できますか？`)
};

const zh_fr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以在替换内容中重复使用匹配到的文本吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq4_q", locale)
	if (locale === "en") return en_fr_faq4_q(inputs)
	if (locale === "es") return es_fr_faq4_q(inputs)
	if (locale === "de") return de_fr_faq4_q(inputs)
	if (locale === "nl") return nl_fr_faq4_q(inputs)
	if (locale === "fr") return fr_fr_faq4_q(inputs)
	if (locale === "it") return it_fr_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq4_q(inputs)
	if (locale === "pt") return pt_fr_faq4_q(inputs)
	if (locale === "ja") return ja_fr_faq4_q(inputs)
	return zh_fr_faq4_q(inputs)
};